import { Modal } from "react-bootstrap";
import HeadOfficeList from "containers/headoffice/HeadOfficeList";

function HeadOfficeModal({
    isAuthenticated,
    user,
    filter,
    saveForm,
    data,
    updateTableState,
    saveRecord,
    deleteRecord,
    validateRelatedRecord,
    leaseid,
    toggleHeadOfficeSearchDialog,
    show, }) {

    if (!isAuthenticated) return null;
    return (
        <div className="componentRendering">
            <Modal show={show} onHide={toggleHeadOfficeSearchDialog} dialogClassName="head-office-modal-wide">
                <Modal.Header closeButton>
                    <Modal.Title>Head Offices with Matching Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <HeadOfficeList
                        filter={filter}
                        isAuthenticated={isAuthenticated}
                        isLoading={false}
                        controlType="table2"
                        saveForm={saveForm}
                        user={user}
                        data={data}
                        updateTableState={updateTableState}
                        saveRecord={saveRecord}
                        deleteRecord={deleteRecord}
                        validateRelatedRecord={validateRelatedRecord}
                        leaseid={leaseid}
                        toggleHeadOfficeSearchDialog={toggleHeadOfficeSearchDialog}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
}
export default HeadOfficeModal;